import React from "react";

const IconBin = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={23}
      height={24}
      viewBox="0 0 23 24"
      fill="none"
      {...props}
    >
      <path
        d="M13.6602 10.7778V18.1111M8.66016 10.7778V18.1111M3.66016 5.88889V20.5556C3.66016 21.2039 3.92355 21.8256 4.39239 22.284C4.86123 22.7425 5.49712 23 6.16016 23H16.1602C16.8232 23 17.4591 22.7425 17.9279 22.284C18.3968 21.8256 18.6602 21.2039 18.6602 20.5556V5.88889M1.16016 5.88889H21.1602M4.91016 5.88889L7.41016 1H14.9102L17.4102 5.88889"
        stroke="#AFAEAE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconBin;
